import { styled, all, layoutSpace, typography, css, flexbox, createGlobalStyle } from '@jamiegardiner/cosmos-system';
import _taggedTemplateLiteral from '@babel/runtime/helpers/taggedTemplateLiteral';
import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React__default, { createElement } from 'react';
import { Fade, Flip, Bounce } from 'react-awesome-reveal';
var Box = styled.div(all);

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    max-width: 1200px;\n    margin: auto;\n    ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Container = styled.div(_templateObject(), all);

function _templateObject$1() {
  var data = _taggedTemplateLiteral(["\n    ", "\n    ", "\n    ", "\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}

var StyledButton = styled.button(_templateObject$1(), layoutSpace, typography, css({
  display: 'inline-flex',
  alignItems: 'center',
  borderRadius: 1,
  minHeight: '48px',
  fontFamily: 'body'
}));
var PrimaryButton = styled(StyledButton)(css({
  bg: 'primary',
  color: 'white'
}));
var SecondaryButton = styled(StyledButton)(css({
  bg: 'secondary',
  color: 'white'
}));
var OutlinedButton = styled(StyledButton)(css({
  bg: 'transparent',
  color: 'primary',
  borderWidth: 2,
  borderColor: 'primary',
  borderStyle: 'solid'
}));
var TextButton = styled(StyledButton)(css({
  bg: 'transparent',
  color: 'primary',
  borderWidth: 0
}));
var variantMap = {
  primary: PrimaryButton,
  secondary: SecondaryButton,
  outlined: OutlinedButton,
  text: TextButton
};
var sizingMap = {
  normal: {
    py: 3,
    px: 5,
    fontSize: 1
  },
  large: {
    py: 6,
    px: 7,
    fontSize: 3,
    fontWeight: 700
  }
};

var Button = function Button(_ref) {
  var children = _ref.children,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'primary' : _ref$variant,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'normal' : _ref$size,
      props = _objectWithoutProperties(_ref, ["children", "variant", "size"]);

  var Component = variantMap[variant];
  var sizing = sizingMap[size];
  return /*#__PURE__*/createElement(Component, _extends({}, props, sizing), /*#__PURE__*/createElement("span", null, children));
};

function _templateObject$2() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    ", "\n    ", "\n"]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}

var Flex = styled.div(_templateObject$2(), all, flexbox);

function _templateObject$3() {
  var data = _taggedTemplateLiteral(["\n  html {\n    -webkit-font-smoothing: auto;\n    -moz-osx-font-smoothing: auto;\n    box-sizing: border-box;\n  }\n\n  *, *::before, *::after  {\n    box-sizing: inherit;\n  }\n\n  body {\n    background-color: ", ";\n    color: ", ";\n    margin: 0;\n    font-family: ", "\n  }\n\n  a {\n    color: ", ";\n    text-decoration: none;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n\n  ol, ul {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    text-indent: 0;\n  }\n\n  h1, h2, h3, h4, h5 {\n    margin: 0 0 0 0;\n  }\n\n  button {\n    border: 0;\n    border-radius: 0;\n    margin: 0;\n    padding: 0;\n    background: transparent;\n\n    &:not(:disabled) {\n      cursor: pointer;\n    }\n  }\n"]);

  _templateObject$3 = function _templateObject() {
    return data;
  };

  return data;
}

var GlobalStyle = createGlobalStyle(_templateObject$3(), function (props) {
  return props.theme.colors ? props.theme.colors.background : '#fff';
}, function (props) {
  return props.theme.colors ? props.theme.colors.text : '#000';
}, function (props) {
  return props.theme.fonts ? props.theme.fonts.body : 'system-ui';
}, function (props) {
  return props.theme.colors ? props.theme.colors.cta : '#3273dc';
});

function _templateObject$4() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject$4 = function _templateObject() {
    return data;
  };

  return data;
}

var defaultProps = {
  fontFamily: 'heading',
  fontWeight: 'heading',
  lineHeight: 'heading'
};
var StyledHeading = styled.span(_templateObject$4(), all);
var fontSizeMap = {
  h1: 5,
  h2: 4,
  h3: 3,
  h4: 2,
  h5: 1
};

var Heading = function Heading(_ref) {
  var level = _ref.level,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["level", "children"]);

  return /*#__PURE__*/createElement(StyledHeading, _extends({
    fontSize: fontSizeMap[level],
    as: level
  }, defaultProps, rest), children);
};

var Message = styled.div(css({
  borderWidth: 0,
  borderLeftWidth: 4,
  borderStyle: 'solid',
  borderColor: 'message.border',
  backgroundColor: 'message.background',
  px: 8,
  py: 7,
  borderRadius: 1,
  color: 'message.text'
}));

function _templateObject$5() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject$5 = function _templateObject() {
    return data;
  };

  return data;
}

var StyledText = styled.span(_templateObject$5(), all);

var Text = function Text(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["children"]);

  return /*#__PURE__*/React__default.createElement(StyledText, _extends({
    fontFamily: "body",
    lineHeight: "body",
    letterSpacing: "body"
  }, rest), children);
};

function _templateObject2() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$6() {
  var data = _taggedTemplateLiteral(["\n    ", "\n    overflow: hidden;\n"]);

  _templateObject$6 = function _templateObject() {
    return data;
  };

  return data;
}

var Wrapper = styled.div(_templateObject$6(), all);
var VideoWrapper = styled('video')(_templateObject2());

var Video = function Video(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["children"]);

  return /*#__PURE__*/React__default.createElement(Wrapper, rest, /*#__PURE__*/React__default.createElement(VideoWrapper, {
    autoPlay: true,
    loop: true,
    muted: true
  }, children));
};

var AnimatedBox = function AnimatedBox(_ref) {
  var children = _ref.children,
      animation = _ref.animation,
      rest = _objectWithoutProperties(_ref, ["children", "animation"]);

  switch (animation) {
    case 'bounce':
      return /*#__PURE__*/React__default.createElement(Bounce, rest, children);

    case 'flip':
      return /*#__PURE__*/React__default.createElement(Flip, rest, children);

    default:
      return /*#__PURE__*/React__default.createElement(Fade, rest, children);
  }
};

export { AnimatedBox, Box, Button, Container, Flex, GlobalStyle, Heading, Message, StyledText, Text, Video };